import React, { useEffect, useState } from 'react'
import CommanForm from '../FormController/Commanform';
import OwnerDetailValidation from '../../yup/MyProfile/OwnerDetail';
import Errormessages from '../ErrorMessage/Errormessages';
import { validImageTypes, validateImage } from '../../utils/Helper';
import { MyProfileUpdateAction } from '../../redux/Action/MyProfileAction';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../Ui/Button';
import $ from "jquery"
import { handleOwnerImageChange } from '../../pages/Profile/CompanyProfile/Image';
import { Form } from 'react-router-dom';

import { FormattedMessage } from 'react-intl';
import { useIntl } from 'react-intl';

const SalonDetailsEdit = ({ profile_data, setOwnerDetailStatus }: any) => {
    const intl = useIntl();

    const dispatch = useDispatch<any>()
    const { register, errors, handleSubmit, setValue, trigger, watch, getValues, setError } = CommanForm({ validationSchema: OwnerDetailValidation });
    const [ownerImage, setOwnerImage] = useState(null)
    const my_profile_data = useSelector((state: any) => state.MyProfileUpdateState);


    const onsubmit = (payload: any) => {

        const data = {
            owner_experience: payload?.experience, profile_pic: ownerImage ? ownerImage : watch("profile_image")
        }
        dispatch(MyProfileUpdateAction(data))
    }


    const handleOwnerImage = (e: any) => { handleOwnerImageChange({ e, setValue, setOwnerImage, validateImage, validImageTypes }) };

    // useEffect(()=>{
    //     setValue("profile_image", ownerImage)
    //     trigger("profile_image")
    // },[ownerImage])


    useEffect(() => {
        setValue("experience", profile_data?.data?.data?.detail?.owner_experience ? profile_data?.data?.data?.detail?.owner_experience : "")
        setValue("profile_image", profile_data?.data?.data?.detail?.profile_pic ? profile_data?.data?.data?.detail?.profile_pic : "")
    }, [profile_data])


    useEffect(() => {
        if (my_profile_data?.status) {
            $(".owner-model-box").click()
            setOwnerDetailStatus(true)
            dispatch(MyProfileUpdateAction("RESET"))
            setOwnerImage(null);
            setValue("profile_image", "");
        }
    }, [my_profile_data])

    const handleClose = () => {
        setValue("experience", profile_data?.data?.data?.detail?.owner_experience ? profile_data?.data?.data?.detail?.owner_experience : "")
        setValue("profile_image", profile_data?.data?.data?.detail?.profile_pic ? profile_data?.data?.data?.detail?.profile_pic : "")
        setError("experience", { type: "experience", message: "" })
        setError("profile_image", { type: "experience", message: "" })
        setOwnerImage(null)
    }

    return (
        <>
            <div className="modal modelStyle fade" id="salonOwnerdetailsEnd" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true"
                ata-bs-backdrop="static" data-bs-keyboard="false"
            >

                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel"><FormattedMessage id="edit_salon_owner_detail" /></h1>
                            {/* <button type="button" className="btn p-0 f-20 btnClose" data-bs-dismiss="modal" aria-label="Close"><span className="icon-close"></span></button> */}
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit(onsubmit)}>
                                <div className='row gy-2'>
                                    <div className='col-12'>
                                        <div className='stafPhoto text-center mb-4' {...register("profile_image")}>


                                            <figure>
                                                {
                                                    ownerImage != undefined && ownerImage || profile_data?.data?.data?.detail?.profile_pic ? <img src={ownerImage ? URL.createObjectURL(ownerImage) : profile_data?.data?.data?.detail?.profile_pic} /> :
                                                        <span className="icon-upload"></span>

                                                }
                                            </figure>


                                            <button type='button' className='btn btn-sm-outline'><span className="icon-edit">
                                            </span> <FormattedMessage id="add_photo" />
                                                <input type='file'   {...(ownerImage ? register("profile_image") : {})} onChange={(e: any) => {
                                                    handleOwnerImage(e)
                                                    trigger("profile_image")
                                                }} />
                                            </button>
                                            <Errormessages errors={errors} name="profile_image" />

                                        </div>

                                        <div className='normalINput'>
                                            <label className="form-label"><FormattedMessage id="owner_experience_years" /></label>
                                            <input type='text' className='form-control'
                                                placeholder={intl.formatMessage({ id: 'enter_year' })}

                                                {...register("experience")}
                                                onInput={(e: any) => {
                                                    const value = e.target.value.replace(/\s{2,}/g, ' ');
                                                    setValue('experience', value);
                                                }}
                                            />
                                            <Errormessages errors={errors} name="experience" />
                                        </div>
                                    </div>
                                </div>
                                <div className='row gy-3 mt-5'>
                                    <div className='col-sm-6'>
                                        <button type="button" className="btn btnOUtlinegray w-100 owner-model-box" data-bs-dismiss="modal" onClick={handleClose} disabled={my_profile_data?.loading}><FormattedMessage id="cancel" /></button>
                                    </div>
                                    <div className='col-sm-6'>
                                        <Button text={<FormattedMessage id="apply" /> as any} type="submit" className="btn btn-fill w-100 min-180" isLoading={my_profile_data?.loading} />
                                        {/* <button type="submit" className="btn btn-fill w-100 min-180">Apply</button> */}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SalonDetailsEdit